class CartPrescriptions {
  constructor() {
    const localStorageKey = 'cartPrescriptions'
    this.prescriptions = []
    
    try {
      this.prescriptions = JSON.parse(localStorage.getItem(localStorageKey)) || []
    } catch(error) {
      localStorage.removeItem(localStorageKey)
      console.error(error)
    }
  }

  addPrescription(prescriptionId, prescription, productType) {
    const existingPrescription = this.prescriptions.find(rx => rx.id === prescriptionId)
    if (existingPrescription) { return }

    const productTypeRxKeys = {
      'Frames': 'spectaclePrescription',
      'Contact Lenses': 'lensPrescription'
    }

    this.prescriptions.push({
      id: prescriptionId,
      [productTypeRxKeys[productType]]: prescription
    })

    this.save()
  }

  save() {
    localStorage.setItem('cartPrescriptions', JSON.stringify(this.prescriptions))
  }

  async deleteOldPrescriptions() {
    this.prescriptions = this.prescriptions
      .filter(rx => rx.lineItemsApplied.length === 0)
    
    this.save()
  }
}

window.cartPrescriptions = new CartPrescriptions()